exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swiper-wrapper {\n  width: 90% !important;\n}", ""]);

// exports
